import styled from 'styled-components';

export default styled.img.attrs({
  src: '/images/copy_link_grey.svg',
})`
  position: absolute;
  top: 0;
  right: calc(0.75rem + 1px);
  height: 3rem;
  width: 1rem;
  text-align: right;
`;
